// extracted by mini-css-extract-plugin
export var chevronIcon = "_bz-2";
export var teamName = "_bz-1";
export var teamSwitcherButton = "_bz-0";